import type { OrderFinancialVO } from "../OrderForms/orders";
import { validateZuuPremiumFinancing } from "./zuuValidation";

export function isPremiumFinancingSectionComplete(
  data: OrderFinancialVO,
  options: { isZuuMode: boolean },
): boolean {
  if (options.isZuuMode) {
    const isPremiumFinanced = data.isPremiumFinanced ?? false;
    if (!isPremiumFinanced) {
      return true;
    }

    return validateZuuPremiumFinancing({
      ...data,
      isPremiumFinanced: true,
    }).length === 0;
  }

  if (typeof data.isPremiumFinanced !== "boolean") {
    return false;
  }

  if (typeof data.hasExistingPolicyAsMortgage !== "boolean") {
    return false;
  }

  return true;
}
